import { render, staticRenderFns } from "./chooseAftSaleGoods.vue?vue&type=template&id=362109f0&"
import script from "./chooseAftSaleGoods.vue?vue&type=script&lang=js&"
export * from "./chooseAftSaleGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports